import { AuthLayout, DefaultLayout } from "@/components/layouts"

export const publicRoute = [
    { path: "*", component: () => import(/* webpackChunkName: "errors-404" */ "@/views/error/NotFound.vue") },
    {
        path: "/auth",
        component: AuthLayout,
        meta: { title: "Login" },
        redirect: "/login",
        hidden: true,
        children: [
            {
                path: "/login",
                name: "login",
                meta: { title: "Login", requiresAuth: false },
                component: () => import(/* webpackChunkName: "login" */ "@/views/auth/Login.vue")
            }
        ]
    },

    {
        path: "/404",
        name: "404",
        meta: { title: "No encontrado", requiresAuth: false },
        component: () => import(/* webpackChunkName: "errors-404" */ "@/views/error/NotFound.vue")
    },

    {
        path: "/500",
        name: "500",
        meta: { title: "Error del servidor", requiresAuth: false },
        component: () => import(/* webpackChunkName: "errors-500" */ "@/views/error/Error.vue")
    }
]

export const protectedRoute = [
    {
        path: "/",
        component: DefaultLayout,
        meta: { title: "Escritorio", group: "apps", icon: "" },
        redirect: "/auth",
        children: [
            {
                path: "/dashboard",
                name: "Dashboard",
                meta: { title: "Escritorio", group: "apps", icon: "dashboard", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard.vue")
            },

            {
                path: "/403",
                name: "Forbidden",
                meta: { title: "Acceso denegado", hiddenInMenu: true, requiresAuth: true },
                component: () => import(/* webpackChunkName: "error-403" */ "@/views/error/Deny.vue")
            },

            {
                path: "/colaborador",
                props: true,
                name: "empleado",
                meta: { title: "Empleado", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "empleado" */ "@/views/personal/empleado/Empleado/Empleado.vue")
            },

            {
                path: "/estudiante",
                props: true,
                name: "estudiante",
                meta: { title: "Estudiante", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "estudiante" */ "@/views/cobranza/estudiante/Estudiante.vue")
            },

            {
                path: "estudiante/curso",
                props: true,
                name: "curso",
                meta: { title: "Curso", requiresAuth: true, breadcrumb: true, parentMenu: "estudiante" },
                component: () => import(/* webpackChunkName: "curso" */ "@/views/cobranza/curso/Curso.vue")
            },

            {
                path: "nomencladores/campus",
                name: "campus",
                meta: { title: "Campus", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "campus" */ "@/views/personal/nomencladores/Campus/Campus.vue")
            },

            {
                path: "nomencladores/campus/seccion/",
                props: true,
                name: "seccion",
                meta: { title: "Sección", requiresAuth: true, breadcrumb: true, parentMenu: "campus" },
                component: () =>
                    import(/* webpackChunkName: "seccion" */ "@/views/personal/nomencladores/Seccion/Seccion.vue")
            },

            {
                path: "nomencladores/departamento",
                name: "departamento",
                meta: { title: "Departamento", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "departamento" */ "@/views/personal/nomencladores/Departamento/Departamento.vue")
            },

            {
                path: "nomencladores/puesto",
                name: "puesto",
                meta: { title: "Puesto", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "puesto" */ "@/views/personal/nomencladores/Puesto/Puesto.vue")
            },

            {
                path: "nomencladores/escolaridad",
                name: "escolaridad",
                meta: { title: "Escolaridad", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "escolaridad" */ "@/views/personal/nomencladores/Escolaridad/Escolaridad.vue")
            },

            {
                path: "nomencladores/estado-civil",
                name: "estado-civil",
                meta: { title: "Estado civil", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "estado-civil" */ "@/views/personal/nomencladores/EstadoCivil/EstadoCivil.vue")
            },

            {
                path: "nomencladores/sexo",
                name: "sexo",
                meta: { title: "Sexo", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "sexo" */ "@/views/personal/nomencladores/Sexo/Sexo.vue")
            },

            {
                path: "nomencladores/titulo",
                name: "titulo",
                meta: { title: "Título", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "titulo" */ "@/views/personal/nomencladores/Titulo/Titulo.vue")
            },

            /*{
                path: "nomencladores/motivo-baja",
                name: "Motivo Baja",
                meta: { title: "Motivo Baja", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/!* webpackChunkName: "MotivoBaja" *!/ "@/views/personal/nomencladores/MotivoBaja/MotivoBaja.vue")
            },*/

            {
                path: "empleados/asistencia",
                props: true,
                name: "asistencia",
                meta: { title: "Asistencia", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "asistencia" */ "@/views/personal/empleado/Asistencia/Asistencia.vue")
            },

            {
                path: "empleados/estadisticas",
                props: true,
                name: "empleado-estadisticas",
                meta: { title: "Estadísticas", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "estadisticas" */ "@/views/personal/estadisticas/Estadisticas.vue")
            },

            {
                path: "empleados/nomina",
                props: true,
                name: "nomina",
                meta: { title: "Prenómina", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "nomina" */ "@/views/personal/empleado/Nomina/Nomina.vue")
            },

            {
                path: "nomencladores/grado",
                name: "grado",
                meta: { title: "Grado", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "grado" */ "@/views/cobranza/nomencladores/Grado/Grado.vue")
            },

            {
                path: "nomencladores/grado/grupo",
                props: true,
                name: "grupo",
                meta: { title: "Grupo", requiresAuth: true, breadcrumb: true, parentMenu: "grado" },
                component: () =>
                    import(/* webpackChunkName: "grupo" */ "@/views/cobranza/nomencladores/Grupo/Grupo.vue")
            },

            {
                path: "/tutor",
                name: "tutor",
                meta: { title: "Tutor", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "tutor" */ "@/views/cobranza/tutor/Tutor.vue")
            },
            {
                path: "nomencladores/ciclo",
                name: "ciclo",
                meta: { title: "Tipo de Ciclo", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "ciclo" */ "@/views/cobranza/nomencladores/Ciclo/Ciclo.vue")
            },

            {
                path: "nomencladores/ciclo/tarifa/",
                props: true,
                name: "tarifa",
                meta: { title: "Tarifa", requiresAuth: true, breadcrumb: true, parentMenu: "ciclo" },
                component: () =>
                    import(/* webpackChunkName: "tarifa" */ "@/views/cobranza/nomencladores/Tarifa/Tarifa.vue")
            },

            {
                path: "nomencladores/tipo-financiamiento",
                name: "tipo-financiamiento",
                meta: { title: "Financiamiento", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "tipofinanciamiento" */ "@/views/cobranza/nomencladores/TipoFinanciamiento/TipoFinanciamiento.vue")
            },

            {
                path: "/user",
                props: true,
                name: "usuario",
                meta: { title: "Usuario", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "usuario" */ "@/views/user/User.vue")
            },

            {
                path: "/solicitud-pago",
                props: true,
                name: "solicitudes-pago",
                meta: { title: "Solicitud de pago", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "solicitud-pago" */ "@/views/finanzas/SolicitudPago.vue")
            },

            {
                path: "/montos",
                props: true,
                name: "solicitud-pago-stats",
                meta: {
                    title: "Montos de Solicitudes de pago",
                    requiresAuth: true,
                    breadcrumb: true
                },
                component: () =>
                    import(/* webpackChunkName: "solicitud-pago-stats" */ "@/components/finanzas/solicitud-pago/solicitud-pago-stats.vue")
            },

            {
                path: "/activo",
                props: true,
                name: "activo",
                meta: { title: "Activo", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "activo" */ "@/views/finanzas/Activo.vue")
            },

            {
                path: "nomencladores/banco",
                name: "banco",
                meta: { title: "Banco", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "banco" */ "@/views/finanzas/nomencladores/Banco/Banco.vue")
            },
            {
                path: "nomencladores/concepto",
                name: "concepto",
                meta: { title: "Concepto", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "concepto" */ "@/views/finanzas/nomencladores/Concepto/Concepto.vue")
            },

            {
                path: "nomencladores/area",
                name: "area",
                meta: { title: "Areas", requiresAuth: true },
                component: () => import(/* webpackChunkName: "area" */ "@/views/finanzas/nomencladores/Area/Area.vue")
            },

            {
                path: "nomencladores/edificio",
                name: "edificio",
                meta: { title: "Edificio", requiresAuth: true },
                component: () =>
                    import(/* webpackChunkName: "edificio" */ "@/views/finanzas/nomencladores/Edificio/Edificio.vue")
            },

            {
                path: "nomencladores/activo-categoria",
                name: "activo-categoria",
                meta: { title: "Categoría", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "categoria" */ "@/views/finanzas/nomencladores/ActivoCategoria/ActivoCategoria.vue")
            },

            {
                path: "nomencladores/activo-estado",
                name: "activo-estado",
                meta: { title: "Estado", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "estado" */ "@/views/finanzas/nomencladores/ActivoEstado/ActivoEstado.vue")
            },

            {
                path: "nomencladores/activo-grupo",
                name: "activo-grupo",
                meta: { title: "Grupo", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "grupo" */ "@/views/finanzas/nomencladores/ActivoGrupo/ActivoGrupo.vue")
            },

            {
                path: "nomencladores/activo-tipo",
                name: "activo-tipo",
                meta: { title: "Tipo", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "tipo" */ "@/views/finanzas/nomencladores/ActivoTipo/ActivoTipo.vue")
            },

            {
                path: "nomencladores/solicitud-pago-categoria",
                name: "solicitud-pago-categoria",
                meta: { title: "Solicitud Pago Categoria", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "solicitud-pago-categoria" */ "@/views/finanzas/nomencladores/SolicitudPagoCategoria/SolicitudPagoCategoria.vue")
            },

            {
                path: "nomencladores/forma-pago",
                name: "forma-pago",
                meta: { title: "Forma de pago", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "forma-pago" */ "@/views/finanzas/nomencladores/FormaPago/FormaPago.vue")
            },

            {
                path: "nomencladores/tipo-monto",
                name: "tipo-monto",
                meta: { title: "Tipo de monto", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "tipomonto" */ "@/views/finanzas/nomencladores/TipoMonto/TipoMonto.vue")
            },

            {
                path: "nomencladores/tipo-sangre",
                name: "tipo-sangre",
                meta: { title: "Tipo de sangre", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "tipo-sangre" */ "@/views/cobranza/nomencladores/Tipo-Sangre/Tipo-Sangre.vue")
            },

            {
                path: "nomencladores/servicio-medico",
                name: "servicio-medico",
                meta: { title: "Servicio médico", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "servicio-medico" */ "@/views/cobranza/nomencladores/Servicio-Medico/Servicio-Medico.vue")
            },

            {
                path: "historial",
                props: true,
                name: "historial",
                meta: { title: "Historial", requiresAuth: true, breadcrumb: true },
                component: () => import(/* webpackChunkName: "historial" */ "@/views/registro/Historial.vue")
            },

            //por ahora no se van a utilizar la tareas
            /*{
                path: "adm-tarea",
                props: true,
                name: "adm-tarea",
                meta: { title: "Tarea", requiresAuth: true, breadcrumb: true },
                component: () => import(/!* webpackChunkName: "adm-tarea" *!/ "@/views/tarea/AdmTarea.vue")
            },

            {
                path: "user-tarea",
                props: true,
                name: "user-tarea",
                meta: { title: "Tarea", requiresAuth: true, breadcrumb: true },
                component: () => import(/!* webpackChunkName: "user-tarea" *!/ "@/views/tarea/UserTarea.vue")
            },*/

            {
                path: "adm-notificacion",
                props: true,
                name: "adm-notificacion",
                meta: { title: "Notificación", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "adm-notificacion-gestor" */ "@/views/notificacion/AdmNotificacionGestor.vue")
            },

            {
                path: "user-notificacion",
                props: true,
                name: "user-notificacion",
                meta: { title: "Notificación", requiresAuth: true, breadcrumb: true },
                component: () =>
                    import(/* webpackChunkName: "user-notificacion" */ "@/views/notificacion/UserNotificacion.vue")
            }
        ]
    }
]
